export default __webpack_public_path__ + "static/media/9_3_hl.75bb0816.png";